TripItemFerryService.SERVICE_NAME = 'tripItemFerryService';

export default function TripItemFerryService() {
    Object.assign(this, {
        getFromToRoute,
        getDepartureDate,
        getArrivalDate,
    });

    function getFromToRoute(recommendation) {
        const firstFerry = getFirstFerry(recommendation);
        const lastFerry = getLastFerry(recommendation);

        if (isOneWay(recommendation)) {
            return `${firstFerry.From} &rarr; ${firstFerry.To}`;
        }

        const allStops = recommendation.FerryInfos.reduce((acc, value) => {
            return [...acc, value.From, value.To];
        }, []);
        const uniqueStops = Array.from(new Set(allStops));
        if (uniqueStops[uniqueStops.length - 1] !== lastFerry.To) {
            uniqueStops.push(lastFerry.To);
        }

        return uniqueStops.join(' &rarr; ');
    }

    function getFirstFerry(recommendation) {
        return recommendation
            && recommendation.FerryInfos
            && recommendation.FerryInfos[0];
    }

    function isOneWay(recommendation) {
        return recommendation.FerryInfos && recommendation.FerryInfos.length === 1;
    }

    function getLastFerry(recommendation) {
        const count = recommendation && recommendation.FerryInfos && recommendation.FerryInfos.length;
        return count && recommendation.FerryInfos[count - 1];
    }

    function getDepartureDate(recommendation) {
        return recommendation
            && recommendation.FerryInfos
            && recommendation.FerryInfos[0]
            && recommendation.FerryInfos[0].DepartureDate;
    }

    function getArrivalDate(recommendation) {
        return (getLastFerry(recommendation) || {}).ArrivalDate || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-ferry/trip-item-ferry-service.js